import styled from "styled-components";
import AppWrapper from "../../layout/AppWrapper";
import Title from "../../utils/Title";
import AllSuppliers from "../../components/user/suppliers/AllSupplier";


function Supplier() {

  return (
    <>
      <AppWrapper
        pagename={"suppliers"}
      >
        <StyledSupplier>
          <Title title={"Supplier"} btnName={""} />
        </StyledSupplier>

        <AllSuppliers />


      </AppWrapper>

    </>
  );
}

export default Supplier;

const StyledSupplier = styled.div`
  

`;